angular.module('ordersModifyGoods', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/orders-modify-goods/orders-modify-goods.module.js